// eslint-disable-next-line no-multiple-empty-lines, import/prefer-default-export
export const defaultCenter: google.maps.LatLngLiteral = { lat: 46.809556574587326, lng: 8.129926932038453 };// Center of Switzerland; { lat: 47.3769, lng: 8.5417 }; // Zurich
export const defaultOptions: google.maps.MapOptions = {
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
  gestureHandling: 'greedy',
  disableDefaultUI: false,
};
